"use client";
import {
  useCompositeGroupLabel
} from "../__chunks/4JE73HZD.js";
import "../__chunks/QHCSOIFP.js";
import "../__chunks/7HVFURXT.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/L4OUMOCQ.js";
import "../__chunks/W2TDKEPX.js";
import "../__chunks/AZVQSWGA.js";

// src/menu/menu-group-label.tsx
var TagName = "div";
var useMenuGroupLabel = createHook(
  function useMenuGroupLabel2(props) {
    props = useCompositeGroupLabel(props);
    return props;
  }
);
var MenuGroupLabel = forwardRef(function MenuGroupLabel2(props) {
  const htmlProps = useMenuGroupLabel(props);
  return createElement(TagName, htmlProps);
});
export {
  MenuGroupLabel,
  useMenuGroupLabel
};
